export const getProductCtasLabels = ({ labels = {}, }) => {
  const { addToCartLabel, removeFromCartLabel, addToMyProductsLabel, removeFromMyProductsLabel, } = labels;
  return {
    addToCartLabel,
    removeFromCartLabel,
    addToMyProductsLabel,
    removeFromMyProductsLabel,
  };
};
